module.exports = __webpack_public_path__ + "static/img/leftsnap.f7192087.svg";